module.exports = __webpack_public_path__ + "img/florin-sign.da93ab63.svg";